import React from 'react';
import SeoHead from '@/components/layout/SeoHead';
import QuoteSection from '@/components/sections/QuoteSection';
import CannotTake from '@/components/sections/CannotTake';
import AcceptancePolicyBlocks from '@/components/sections/AcceptancePolicyBlocks';
import { BRAND } from '@/data/site';

export default function Contact() {
  return (
    <>
      <SeoHead
        title="Contact / Get a Quote | Ohana Property Services"
        description="Send a quote request to Ohana Property Services. Photo-based quotes for junk removal, cleanouts, estate transitions, and debris removal across Central Indiana."
        canonical="https://ohanapropertyexperts.com/contact"
      />

      <section className="bg-ohana-primary text-ohana-bg">
        <div className="container-ohana pt-24 pb-16 md:pt-32 md:pb-20">
          <p className="overline">Contact</p>
          <h1 className="mt-4 font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.05] max-w-4xl">
            Tell us about the project.
          </h1>
          <p className="mt-6 text-lg md:text-xl text-ohana-bg/75 max-w-2xl">
            Most quotes go out the same day. The more photos you can share, the faster and more accurate the number.
          </p>
        </div>
      </section>

      <section
        className="section-pad bg-ohana-bg border-b border-ohana-border"
        data-testid="acceptance-policy-gate"
      >
        <div className="container-ohana">
          <div className="max-w-3xl">
            <p className="overline">Self-Screen Before You Submit</p>
            <h2 className="h-display text-3xl md:text-4xl mt-3 leading-tight">
              Before You Submit Your Quote Request
            </h2>
            <p className="mt-5 text-ohana-text-muted text-base md:text-lg leading-relaxed">
              A quick read so we can get you a quote faster. If your items fall outside our acceptance policy we will help direct you to the correct disposal resource. That saves you a wasted trip and us a wasted dispatch.
            </p>
          </div>
          <div className="mt-10">
            <AcceptancePolicyBlocks />
          </div>
        </div>
      </section>

      <QuoteSection />

      <CannotTake />

      <section className="bg-ohana-surface border-t border-ohana-border">
        <div className="container-ohana py-12 text-center">
          <p className="text-xs text-ohana-text-muted leading-relaxed max-w-2xl mx-auto" data-testid="contact-legal">
            Quote requests are submitted to <strong>{BRAND.legal}</strong>, doing business as {BRAND.name}.
          </p>
        </div>
      </section>
    </>
  );
}
